import fetch from "auth/FetchInterceptor";

const BulkEmailService = {};

const prefix = "/bulk-emails";

BulkEmailService.send = async (data) =>
  await fetch(prefix, { method: "POST", data });

BulkEmailService.getAll = async (params = {}) => {
  const qp = new URLSearchParams();
  if (params.page) qp.append("page", params.page);
  if (params.limit) qp.append("limit", params.limit);
  if (params.status && params.status !== "all") qp.append("status", params.status);
  const qs = qp.toString() ? `?${qp.toString()}` : "";
  return fetch(`${prefix}${qs}`, { method: "GET" });
};

BulkEmailService.getById = async (id) =>
  await fetch(`${prefix}/${id}`, { method: "GET" });

BulkEmailService.getRecipientsCount = async (params = {}) => {
  const qp = new URLSearchParams();
  if (params.recipientType) qp.append("recipientType", params.recipientType);
  if (params.formationId) qp.append("formationId", params.formationId);
  if (params.groupId) qp.append("groupId", params.groupId);
  const qs = qp.toString() ? `?${qp.toString()}` : "";
  return fetch(`${prefix}/recipients-count${qs}`, { method: "GET" });
};

BulkEmailService.getRecipientsList = async (params = {}) => {
  const qp = new URLSearchParams();
  if (params.recipientType) qp.append("recipientType", params.recipientType);
  if (params.formationId) qp.append("formationId", params.formationId);
  if (params.groupId) qp.append("groupId", params.groupId);
  const qs = qp.toString() ? `?${qp.toString()}` : "";
  return fetch(`${prefix}/recipients-list${qs}`, { method: "GET" });
};

BulkEmailService.deleteById = async (id) =>
  await fetch(`${prefix}/${id}`, { method: "DELETE" });

export default BulkEmailService;
